export default "__VITE_ASSET__Tyn53RBf__"